import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const useBudgetCategoryOptions = (budgetCategoryId) => {
  const queryFn = useApiRequest({
    url: `budget-categories/${budgetCategoryId}/options`,
    method: HttpMethod.Get,
  });

  return useQuery({
    enabled: !!budgetCategoryId,
    queryKey: ["budget-category-options", budgetCategoryId],
    queryFn,
    placeholderData: [],
  });
};
